import { createFeatureSelector, createSelector } from "@ngrx/store";
import { taskFolderFeatureKey, TaskFolderState } from "./task-folder.reducer";

export const selectTaskFolderState =
  createFeatureSelector<TaskFolderState>(taskFolderFeatureKey);

export const selectTaskFolders = createSelector(
  selectTaskFolderState,
  state => state.folders
);

export const selectTaskFoldersLoading = createSelector(
  selectTaskFolderState,
  state => state.loading
);

export const selectTaskFoldersLoaded = createSelector(
  selectTaskFolderState,
  state => state.loaded
);

export const selectTaskFoldersError = createSelector(
  selectTaskFolderState,
  state => state.error
);
